import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from "prop-types"
import i18n from 'i18n/index.js'
import LandingImage from "components/products/LandingImage";
import { buildLocalePath } from "components/utils/Locale";

function Landing(props) {
    const [slug, setSlug] = useState("");
    useEffect(() => {
        if (props.landing) {
            if (props.landing?.slug) {
                setSlug(props.landing?.slug)
            }
        }
    }, [props.landing]);

    const landingHref = buildLocalePath("landings/" + (slug != null ? slug : props.landing?.id));

    return (
        <a
            href={landingHref}
            title="View Details"
            target="_blank"
            rel="noopener noreferrer"
            className="landing-card-link oi-w-full"
        >
            <div className="landing-card oi-w-full">
                <LandingImage
                    key={"landing-image-" + props.landing?.id}
                    landing={props.landing}
                    image_format={props.image_format}
                    skeleton_height={(props.skeleton_height ? props.skeleton_height : 320)}
                />
                <div className="landing-text-block">
                    {
                        props.landing.place &&
                        <h3 className="zone">{props.landing.title}</h3>
                    }

                    <p>{props.landing?.place}</p>

                </div>
            </div>
        </a>
    );
}

export default Landing
